import { render, staticRenderFns } from "./calendar-services-list.vue?vue&type=template&id=cdbb3746"
import script from "./calendar-services-list.vue?vue&type=script&lang=js"
export * from "./calendar-services-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports